import styled from 'styled-components';

export const Container = styled.div`
  background: var(--secondary-wrapper-bg);
  cursor: default;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--label-color);
`;

export const StyledErrorContainer = styled.div`
  justify-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  text-align: center;
  max-width: 540px;
`;

export const StyledTitle = styled.h1`
  font-size: 20px;
  margin: 0;
  font-weight: 500;
`;

export const StyledMessage = styled.p`
  font-size: 16px;
  margin-bottom: 16px;
  margin-top: 0;
  white-space: pre-line;
`;

export const StyledWrapper = styled.div`
  width: auto;
  margin: auto;
`;

export const StyledImage = styled.img`
  margin: auto;
  width: 100px;
  height: 100px;
`;
